module.exports = __webpack_public_path__ + "static/media/wedoboth.d7683b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/wedo/wedoboth.png
// module id = 158
// module chunks = 0